import React from "react";
import {useField} from "formik";
import MaskedInput from 'react-text-mask'
import createNumberMask from 'text-mask-addons/dist/createNumberMask'

import styles from './styles.module.scss'

const defaultMaskOptions = {
  prefix: '',
  suffix: '',
  includeThousandsSeparator: false,
  thousandsSeparatorSymbol: '',
  allowDecimal: true,
  decimalLimit: 2,
  integerLimit: 9,
  allowNegative: false,
  allowLeadingZeroes: false,
};

export const FieldNumber = ({...props}) => {
  const [field, meta] = useField(props);

  //Classes
  const cls = [styles.field__input];

  if (meta.touched && meta.error) {
    cls.push(styles.field__input_error)
  }
  //END Classes

  //const mask = /^[9{1,9}[,99][.99]]+$/;
  const currencyMask = createNumberMask({
    ...defaultMaskOptions,
  });

  return (
    <div className={styles.field}>
      <div className={styles.field__group}>
        <label className={styles.field__label} htmlFor={props.id}>{props.label}</label>
        <MaskedInput
          className={cls.join(' ')}
          { ...field }
          mask={currencyMask}
          placeholder={props.placeholder}
          type={props.type}
          id={props.id}
          //inputmode="numeric"
          //pattern="[0-9]+([\.][0-9]+)?"
        />
      </div>
    </div>
  )
};
